import { render, staticRenderFns } from "./ProductFeatureItem.vue?vue&type=template&id=40589132&scoped=true"
import script from "./ProductFeatureItem.vue?vue&type=script&lang=js"
export * from "./ProductFeatureItem.vue?vue&type=script&lang=js"
import style0 from "./ProductFeatureItem.vue?vue&type=style&index=0&id=40589132&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40589132",
  null
  
)

export default component.exports